import React, { Component } from 'react';
import i18n from 'utils/translate';
import UserLocationFiltering from '../UserLocationFiltering';

const defaultProps = {
  filters: [],
  showUserLocationFiltering: false,
  onLocationClick: () => {}
};

class NoResults extends Component {
  render() {
    return (
      <div>
        <h2 className="results-main-heading">{i18n('no-results')}</h2>
        <div>
          {this.props.showUserLocationFiltering ? (
            <span className="hidden-xs hidden-sm">
              &nbsp;
              <UserLocationFiltering onLocationClick={this.props.onLocationClick}></UserLocationFiltering>
            </span>
          ) : null}
        </div>
      </div>
    );
  }
}

NoResults.defaultProps = defaultProps;

export default NoResults;
